import React, { useRef } from "react";
import { HeroSection } from "./HeroSection";
import { EmpowerStatement } from "./EmpowerStatement";
import { FeatureCards } from "./FeatureCards";
import { WhyMinEMI } from "./WhyMinEMI";
import { JourneySections } from "./JourneySections";
import { ComparisonSection } from "./ComparisonSection";
import { NewsSection } from "./NewsSection";
import { LendingPartners } from "./LendingPartners";

export default function NewHomePage() {
  const comparisonRef = useRef(null);

  return (
    <div className="min-h-screen w-full flex flex-col">
      <main className="flex flex-col">
        <HeroSection comparisonRef={comparisonRef} />
        <EmpowerStatement />
        <FeatureCards />
        <WhyMinEMI />
        <JourneySections />
        {/* Attach the ref to the ComparisonSection */}
        <div ref={comparisonRef}>
          <ComparisonSection />
        </div>
        <NewsSection />
        <LendingPartners />
      </main>
    </div>
  );
}
